const URBAN_COLORS = {
  primary: '#215DF4',
  secondary: '#699FFF',
  tertiary: '#C5EAFF',
};

const STARTUP_COLORS = {
  primary: '#3FBAFE',
  secondary: '#72D0F6',
  tertiary: '#CCECFB',
};

const ARENA_COLORS = {
  primary: '#7F2982',
  secondary: '#CE7AD2',
  tertiary: '#EFBAF2',
};

const RURAL_COLORS = {
  primary: '#32843A',
  secondary: '#4CB24F',
  tertiary: '#32843A',
};

export const COLORS_CONFIG = {
  1: URBAN_COLORS,
  2: STARTUP_COLORS,
  3: ARENA_COLORS,
  4: RURAL_COLORS,
};
